module.exports = __webpack_public_path__ + "a4a7c11a98524437a8e57dc7f7ecb83b.svg";